// extracted by mini-css-extract-plugin
export default {"wrapper":"Q3-z","play":"R3-z"};